import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login/Login.vue";
import OrderInvoice from "../views/orderinvoice/OrderInvoice.vue";
import OrderInvoiceDetail from "../views/orderinvoice/OrderInvoiceDetail.vue";
import User from "../views/user/UserDetail.vue";
import AddUser from "../views/user/AddUser.vue";
import Construction from "../views/construction/Construction.vue";
import AddConstruction from "../views/construction/AddConstruction.vue";
import Company from "../views/company/Company.vue";
import AddCompany from "../views/company/AddCompany.vue";
import Order from "../views/order/Order.vue";
import Invoice from "../views/invoice/Invoice.vue";
// import ChoiceCon from "../views/ChoiceConstruction/ChoiceConstruction.vue";
import SelectArea from "@/views/ChoiceConstruction/SelectArea.vue";
import QrCodeData from "../views/qrcode/QrCodeData";
import Approval from "../views/confirm/index.vue";
import FindUserInfomation from "../views/login/FindUserInfomation.vue";
import NotFound from "@/views/notFound/index.vue";
import store from "@/store";
import { checkAndRedirect } from "@/config/redirect";

import Store from "../views/store/store.vue";
import DashBoard from "../views/dashBoard/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
  },
  {
    path: "/choiceCon",
    name: "ChoiceCon",
    component: SelectArea,
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    props: true,
  },
  {
    path: "/idFind",
    name: "IdFind",
    component: FindUserInfomation,
    props: true,
  },

  {
    path: "/passFind",
    name: "PassFind",
    component: FindUserInfomation,
    props: true,
  },
  {
    path: "/orderinvoice",
    name: "OrderInvoice",
    component: OrderInvoice,
  },
  {
    path: "/orderinvoice/detail",
    name: "OrderinvoiceDetail",
    component: OrderInvoiceDetail,
    props: true,
  },
  {
    path: "/user",
    name: "User",
    component: User,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/user/add",
    name: "AddUser",
    component: AddUser,
    props: true,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/construction",
    name: "Construction",
    component: Construction,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/construction/add",
    name: "AddConstruction",
    component: AddConstruction,
    props: true,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/company",
    name: "Company",
    component: Company,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/company/add",
    name: "AddCompany",
    component: AddCompany,
    props: true,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/order",
    name: "Order",
    component: Order,
  },

  {
    path: "/invoice",
    name: "Invoice",
    component: Invoice,
  },

  {
    path: "/store",
    name: "Store",
    component: Store,
  },

  {
    path: "/qrCode",
    name: "qrCode",
    component: QrCodeData,
    props: true,
  },
  {
    path: "/approval",
    name: "Approval",
    component: Approval,
    props: true,
    meta: { authorization: ["admin"] },
  },
  {
    path: "/dashBoard",
    name: "DashBoard",
    component: DashBoard,
    props: true,
  },
  {
    path: "/notfound",
    name: "notFound",
    component: NotFound,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/notfound",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  /** 도메인 리다이렉트 체크 : 특정 도메인/포트로 접속 시 리다이렉트 */
  checkAndRedirect();

  const isLoggedIn = store?.state?.User?.userList;
  const { authorization } = to.meta;
  const isViewRole = isLoggedIn?.roleType === "뷰어";

  // 권한페이지에 뷰어면 리다이렉트
  if (authorization && isLoggedIn && isViewRole) {
    return next({ name: "DashBoard" });
  }
  // 로그인,아이디찾기,비번찾기 페이지 외 접속 시, 로그인 안했으면 리다이렉트
  if (
    !isLoggedIn &&
    to.name !== "Login" &&
    to.name !== "IdFind" &&
    to.name !== "PassFind"
  ) {
    return next({ name: "Login" });
  }
  next();
});

export default router;
